import { Component, OnInit, Input, OnDestroy} from '@angular/core';
import { TextdisplayComponent } from '../textdisplay/textdisplay.component';
import { MenuService } from '../../../services/menu.service';
import { DataIoService } from '../../../services/data-io.service';
import { ConfigService } from '../../../services/config.service';
import { TranslationService } from '../../../services/translation.service';
import { Helper, MenuNode,BaseSensor } from '../../../classes';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss']
})

export class SplashComponent implements OnInit,OnDestroy {
  node:MenuNode;
  constructor(
  	private ioService : DataIoService, 
  	private configService : ConfigService, 
  	private translator : TranslationService, 
  	private menuService : MenuService
  	) {

  }

  get dashIcon():string{
    console.log("Showing icon: "+this.node.getIcon());
  	return this.node.getIcon();
  }

  getText(idx:number){
  	return this.node.getText(idx);
  }

  ngOnInit() {
    this.node = this.menuService.getCurrentNode();
  }

  ngOnDestroy(){

  }
}
